import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-space-50"
}
const _hoisted_2 = { class: "container-lil" }
const _hoisted_3 = { class: "s10_mobile" }
const _hoisted_4 = { class: "widget px-6 pt-5" }
const _hoisted_5 = { class: "grid-web4" }
const _hoisted_6 = {
  class: "img-area rounded-20 mx-1 mb-3 px-3 py-2",
  style: {"height":"70px","overflow":"hidden","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "price secondary-font mb-3 text-center" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "s9_mobile" }

import { inject, onMounted, reactive, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import MarketCartInfos from './../../components/MarketCartInfos.vue';
import MarketCheckoutModeLivraisonForm from './MarketCheckoutModeLivraisonForm.vue';
import { useMarketCartStore } from '@/stores/cart.store';
import { storeToRefs } from 'pinia';
import MarketCheckoutAdressesListModal from '../../modals/MarketCheckoutAdressesListModal.vue';
import axios from 'axios';
import { showAlert } from '@/utils/swal';


export default /*@__PURE__*/_defineComponent({
  __name: 'MarketCheckoutView',
  setup(__props) {

const BACKEND_URL = inject('BACKEND_URL');
const router = useRouter();
const layout = ref('none');
const cart = useMarketCartStore();
const { items } = storeToRefs(cart);
const loading = ref(false);
const errorMessage = ref('');
const isCheckoutFormValid = ref(false);
const checkoutForm = reactive({
    mode_livraison: -1,
    adresse: null as any | null,
});
const checkoutFormErrors = reactive({
    mode_livraison: "",
    adresse: "",
});
const startupInfos = reactive({
    adresses: [] as any[],
});
const adressesListModalRef = ref<InstanceType<typeof MarketCheckoutAdressesListModal> | null>(null);

onMounted(() => {
    layout.value = router.currentRoute.value.meta.layout as string || 'none';
    Object.assign(startupInfos, router.currentRoute.value.meta.startup_infos);
    if (startupInfos.adresses.length > 0) {
        const defaultAdresse = startupInfos.adresses.find(a => a.is_default);
        if (defaultAdresse) {
            checkoutForm.adresse = defaultAdresse;
        } else {
            checkoutForm.adresse = startupInfos.adresses[0];
        }
    }
});

watch(checkoutForm, (oldFormData, newFormData) => {
    validateCheckoutFOrm();
});

function validateCheckoutFOrm() {
    let isValid = true;

    checkoutFormErrors.mode_livraison = "";
    if (!checkoutForm.mode_livraison) {
        checkoutFormErrors.mode_livraison = "Veuillez sélectionner un mode de livraison";
        isValid = false;
    }

    if (checkoutForm.mode_livraison !== -1) {
        checkoutFormErrors.adresse = "";
        if (!checkoutForm.adresse) {
            checkoutFormErrors.adresse = "Veuillez sélectionner une adresse de livraison";
            isValid = false;
        }
    }

    isCheckoutFormValid.value = isValid;

    return isValid;
}

function onModeLivraisonSelected(mode_livraison_id: number) {
    checkoutForm.mode_livraison = mode_livraison_id;
}

async function openAdressesListModal() {
    const selectedAdresse = await adressesListModalRef.value?.open(startupInfos.adresses);
    if (selectedAdresse) {
        checkoutForm.adresse = selectedAdresse;
    }
}

async function onSubmitModeLivraisonForm() {
    if (!validateCheckoutFOrm()) {
        return;
    }
    loading.value = true;
    try {
        await axios.post(`/market/create_commande`, {
            type_livraison_id: checkoutForm.mode_livraison,
            adresse_livraison_id: checkoutForm.adresse?.id,
            items: cart.items.map(item => ({
                produit_id: item.id,
                quantite: item.quantite,
                prix_unitaire: item.montant,
            })),
            subtotal: cart.getSubTotal,
            total: cart.getTotal,
        });
        router.push('/front/market/commandes');
    } catch (error: any) {
        errorMessage.value = error.message || 'Une erreur est survenue lors de la validation de votre commande. Veuillez réessayer.';
        await showAlert.error(errorMessage.value);
        loading.value = false;
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (layout.value == 'none')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "secondary-font mb-4" }, "Ma commande", -1)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _unref(BACKEND_URL) + '/assets/market_produits/300/' + item.image,
                    style: {"max-width":"100%","max-height":"60px"}
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("h5", _hoisted_8, "x" + _toDisplayString(item.quantite), 1)
              ]))
            }), 128))
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "clear-both h-25" }, null, -1)),
        _createVNode(MarketCheckoutModeLivraisonForm, {
          "onUpdate:modelValue": onModeLivraisonSelected,
          onOnEditAdresse: openAdressesListModal,
          startupInfos: startupInfos,
          adresse: checkoutForm.adresse
        }, null, 8, ["startupInfos", "adresse"]),
        _createElementVNode("button", {
          class: _normalizeClass(["btn-ultra lg w-100 flex-center", {'loading': loading.value}]),
          disabled: !isCheckoutFormValid.value || loading.value,
          onClick: onSubmitModeLivraisonForm
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "btn-show" }, [
            _createElementVNode("span", null, "Valider")
          ], -1),
          _createElementVNode("div", { class: "btn-loading" }, [
            _createElementVNode("div", { class: "loader-dots" })
          ], -1)
        ]))], 10, _hoisted_9),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1))
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "s1_mobile" }, " ", -1)),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(MarketCartInfos, {
          layout: layout.value,
          "hide-button": true
        }, null, 8, ["layout"])
      ])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1)),
    _createVNode(MarketCheckoutAdressesListModal, {
      ref_key: "adressesListModalRef",
      ref: adressesListModalRef
    }, null, 512)
  ], 64))
}
}

})